import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-064353c2"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "info-window-header" };
var _hoisted_2 = ["href"];
var _hoisted_3 = { class: "info-window-title-wrapper" };
var _hoisted_4 = { class: "info-window-row" };
var _hoisted_5 = { class: "info-window-row" };
var _hoisted_6 = { class: "info-window-row" };
var _hoisted_7 = { class: "info-window-row" };
var _hoisted_8 = { class: "info-window-row" };
var _hoisted_9 = ["href"];
var _hoisted_10 = { key: 1 };
var _hoisted_11 = { class: "info-window-row" };
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import TeamType from '../../../team/TeamType';
import { key } from '../../../../store';
import useTransportMarkerSpecs from '../../../generic/transport/useTransportMarkerSpecs';
import MarkerInfoWindow from './MarkerInfoWindow.vue';
import PiloteIcon from '../../../generic/PiloteIcon.vue';
import PiloteModal from '../../../generic/modal/PiloteModal.vue';
var MILLISECONDS_PER_MINUTE = 60 * 1000;
export default /*#__PURE__*/ _defineComponent({
    __name: 'TeamMarkerInfoWindow',
    props: {
        team: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        var t = useI18n({ useScope: 'global' }).t;
        var store = useStore(key);
        var UNKNOWN = t('team.infoWindow.unknown');
        var teamPageHyperlink = computed(function () { return "/app/team/".concat(props.team.id); });
        var waitTimeInMinutes = computed(function () {
            if (props.team.inReturnSince) {
                var lastRide = new Date(props.team.inReturnSince);
                var now = new Date();
                return "".concat(Math.round((now.getTime() - lastRide.getTime()) / MILLISECONDS_PER_MINUTE), " min");
            }
            return UNKNOWN;
        });
        var motorType = computed(function () {
            return props.team.vehicleElectrical ? t('team.infoWindow.motorType.electric') : t('team.infoWindow.motorType.gas');
        });
        var transmissionType = computed(function () {
            return props.team.manual ? t('team.infoWindow.transmission.manual') : t('team.infoWindow.transmission.automatic');
        });
        var assignedTransport = computed(function () { return store.getters['transports/getTransportByTeamId'](props.team.id); });
        var formatTransportPageHyperlink = function (transport) { return "/app/transport/".concat((transport === null || transport === void 0 ? void 0 : transport.transportRequestId) || ''); };
        var formatAssignedTransport = function (transport) {
            if (transport) {
                var label = useTransportMarkerSpecs(transport).label;
                return "".concat(label.text, ", #").concat(transport.transportRequestId);
            }
            return '';
        };
        var teamStatus = computed(function () { return (props.team.status ? t("team.status.tooltip.".concat(props.team.status)) : UNKNOWN); });
        var isVip = computed(function () {
            if (!props.team.type)
                return UNKNOWN;
            return props.team.type === TeamType.VIP ? t('team.infoWindow.vip.yes') : t('team.infoWindow.vip.no');
        });
        var isExclusionModalVisible = ref(false);
        var exclusionModalTitle = computed(function () {
            var prefix = t('team.infoWindow.assistedAssignment.exclusionModal.titlePrefix');
            var suffix = t('team.infoWindow.assistedAssignment.exclusionModal.titleSuffix');
            return "".concat(prefix, " #").concat(props.team.number, " ").concat(suffix);
        });
        var showExclusionModal = function () {
            isExclusionModalVisible.value = true;
        };
        var hideExclusionModal = function () {
            isExclusionModalVisible.value = false;
        };
        var enableAssistedAssignment = function () {
            store.dispatch('teams/enableAssistedAssignmentForTeam', props.team.id);
        };
        var disableAssistedAssignment = function () {
            isExclusionModalVisible.value = false;
            store.dispatch('teams/disableAssistedAssignmentForTeam', props.team.id);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(MarkerInfoWindow, null, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("a", {
                                href: teamPageHyperlink.value,
                                target: "_blank",
                                class: "info-window-hyperlink"
                            }, [
                                _createElementVNode("span", _hoisted_3, [
                                    _createElementVNode("b", null, _toDisplayString("".concat(_unref(t)('team.infoWindow.team'), " ").concat(__props.team.number)), 1 /* TEXT */)
                                ])
                            ], 8 /* PROPS */, _hoisted_2)
                        ])
                    ]; }),
                    content: _withCtx(function () { return [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.waitTime')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(waitTimeInMinutes.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.motorType.label')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(motorType.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.transmission.label')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(transmissionType.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.status')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(teamStatus.value), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.assignedTo.label')) + " : ", 1 /* TEXT */),
                                (assignedTransport.value)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: formatTransportPageHyperlink(assignedTransport.value),
                                        target: "_blank",
                                        class: "info-window-hyperlink"
                                    }, _toDisplayString(formatAssignedTransport(assignedTransport.value)), 9 /* TEXT, PROPS */, _hoisted_9))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)('team.infoWindow.assignedTo.none')), 1 /* TEXT */))
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("b", null, _toDisplayString(_unref(t)('team.infoWindow.vip.label')) + " : ", 1 /* TEXT */),
                                _createTextVNode(_toDisplayString(isVip.value), 1 /* TEXT */)
                            ])
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        (__props.team.isAssistedAssignmentEnabled)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "exclusion-button",
                                onClick: showExclusionModal
                            }, [
                                _createVNode(PiloteIcon, {
                                    icon: "forbidden",
                                    fill: "gray",
                                    class: "button-icon"
                                }),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('team.infoWindow.assistedAssignment.exclude')), 1 /* TEXT */)
                            ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "exclusion-button",
                                onClick: enableAssistedAssignment
                            }, [
                                _createVNode(PiloteIcon, {
                                    icon: "gear",
                                    fill: "gray",
                                    class: "button-icon"
                                }),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('team.infoWindow.assistedAssignment.include')), 1 /* TEXT */)
                            ]))
                    ]; }),
                    _: 1 /* STABLE */
                }),
                _createVNode(PiloteModal, {
                    show: isExclusionModalVisible.value,
                    title: exclusionModalTitle.value,
                    confirm: disableAssistedAssignment,
                    "confirm-label": _unref(t)('team.infoWindow.assistedAssignment.exclusionModal.confirmLabel'),
                    close: hideExclusionModal,
                    "close-label": _unref(t)('team.infoWindow.assistedAssignment.exclusionModal.closeLabel')
                }, null, 8 /* PROPS */, ["show", "title", "confirm-label", "close-label"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
